import React, { useState } from 'react';
import styled from 'styled-components';

import { Text } from '../../../../../../components';
import ModalTableCheckboxSearch from '../../../../../../components/ModalTableCheckboxSearch';
import { agentType, agentTypeOptionList } from '../../../../../../constants/order';
import { agentTableKey, agentTableHeader } from './constants';
import { Colors } from '../../../../../../constants/Colors';
import { Box, Chip, Tooltip } from '@material-ui/core';

const AddressWrapper = styled.div`
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;
`;

const AgentWrapper = styled.div`
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;
`;

export const TagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 4px 0;
`;

export const Tag = styled.div`
  border: 1px solid ${Colors.GRAY};
  border-radius: 16px;
  padding: 4px 8px;
  color: ${Colors.GRAY_DARKER};
  font-size: 14px;
  margin: 4px 4px 4px 0;
`;

const AgentsModalTable = ({
  handleRefresh,
  ...props
}) => {
  const [isRefresh, setIsRefresh] = useState(false);
  
  const columnConfig = {
    [agentTableKey.AGENT]: {
      order: 1,
      width: 195,
    },
    [agentTableKey.CITY]: {
      order: 2,
      width: 185,
    },
    [agentTableKey.TAG]: {
      order: 3,
      width: 205,
    },
  };

  const components = {
    [agentTableKey.AGENT]: (fieldData, data, rowIndex) => {
      const rowData = data[rowIndex];
      return (
        <Tooltip title={rowData.name} placement="top" arrow>
          <AgentWrapper>
            {rowData.name}
            <br />
            <span>{`${rowData.customerCode || ""}`}</span>
          </AgentWrapper>
        </Tooltip>
      );
    },
    [agentTableKey.CITY]: (fieldData, data, rowIndex) => {
      const rowData = data[rowIndex];
      const cityAndState = `${rowData.city} - ${rowData.uf}`;

      return (
        <Tooltip title={cityAndState} placement="top" arrow>
          <AddressWrapper>
            <Text>{cityAndState}</Text>
          </AddressWrapper>
        </Tooltip>
      );
    },
    [agentTableKey.TAG]: (tags) => {
      const visibleCategories = tags.slice(0, 1);
      const hiddenCategories = tags.slice(1);

      if (tags.length > 1) {
        return (
          <>
            <Box
              maxHeight={48}
              overflow="hidden"
              display="flex"
              flexWrap="wrap"
              alignItems="center"
            >
              {visibleCategories.map((tag, index) => (
                <Tag key={`${props.name}-${tag.id}`}>{tag.name}</Tag>
              ))}
              <Tooltip
                title={
                  <Box display="flex" flexWrap="wrap">
                    {hiddenCategories.map((tag, index) => (
                      <Chip
                        key={index}
                        label={tag.name}
                        style={{ margin: 2 }}
                        size="small"
                        color="default"
                      />
                    ))}
                  </Box>
                }
                arrow
                interactive
                placement="top"
              >
                {hiddenCategories.length > 0 && (
                  <Tag>{`+${hiddenCategories.length}`}</Tag>
                )}
              </Tooltip>
            </Box>
          </>
            
        );
      } else {
        return (
          <TagWrapper>
            {tags.map((tag) => (
              <Tag key={`${props.name}-${tag.id}`}>{tag.name}</Tag>
            ))}
          </TagWrapper>
        );
      }
    },
  };

  return (
    <ModalTableCheckboxSearch
      title="Selecione um representante"
      placeholder={(option) => agentType.NAME === option.type ? 'Nome do representante' : 'Tag do representante'}
      tableColumnConfig={columnConfig}
      tableComponents={components}
      searchTypeList={agentTypeOptionList}
      tableHandleHeaderTitle={(key) => agentTableHeader[key]}
      handleRefresh={() => {
        handleRefresh();
        setIsRefresh(true);
      }}
      isRefresh={isRefresh}
      disableConfirm
      {...props}
    />
  );
};

export default AgentsModalTable;
